import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import FullPageLoadingIndicator from '../LoadingIndicator/FullPageLoadingIndicator';
import { APP_ROUTES } from './../../utils/AppConstants';
import { HandleStepUp } from './ReducerActions/HandleStepUp';

const StepUpHandler = ({ logger, oidc }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    // This callback handler function is passed to the OIDC method below
    // This will be called after token requests and exchanges for new JWT are completed
    const callbackHandler = (jwt, sessionCorrelationId, returnPath) => {
        if (jwt) {
            // If no JWT is received, we know the step up wasn't completed
            dispatch(HandleStepUp(jwt, sessionCorrelationId));
        }

        // Send member back to the page they were trying to access before triggering step up
        const destination = APP_ROUTES[returnPath]?.url || APP_ROUTES.basePath;

        return history.push(destination);
    };

    useEffect(() => {
        const transactionId = logger.generateGuid();
        oidc.stepUpCallback(callbackHandler, transactionId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <FullPageLoadingIndicator />;
};

export default StepUpHandler;
